import React from "react";
import { motion } from "framer-motion";
import DotChart from "./DotChart";

// Module-level animation configs — stable references, no re-creation per render.
const REVEAL = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.5 },
};

const VERSE_REVEAL = {
  ...REVEAL,
  viewport: { once: true, amount: 0.25 },
};

export default function ChapterBlock({ block, isFirst }) {
  if (block.type === "verse") {
    return (
      <motion.div {...VERSE_REVEAL} className="space-y-1">
        {block.lines.map((line, j) => (
          <span key={`${j}:${line}`} className="verse-line">
            {line}
          </span>
        ))}
      </motion.div>
    );
  }
  if (block.type === "dotchart") {
    return <DotChart caption={block.caption} />;
  }
  if (block.type === "footnote") {
    return (
      <motion.aside {...REVEAL} className="footnote-block">
        <span className="text-[hsl(var(--primary))] font-bold mr-1">*</span>
        {block.text}
      </motion.aside>
    );
  }
  if (block.type === "quote") {
    return (
      <motion.blockquote {...REVEAL} className="quote-block">
        {block.text}
      </motion.blockquote>
    );
  }
  if (block.type === "emphasis") {
    return (
      <motion.p {...REVEAL} className="emphasis-block">
        {block.text}
      </motion.p>
    );
  }
  return (
    <motion.p
      {...REVEAL}
      className={"prose-paragraph " + (isFirst ? "drop-cap" : "")}
    >
      {block.text}
    </motion.p>
  );
}
